import React, { Fragment } from "react";
import { Row, Col } from "antd";

const Other = ({ dob, nickname, sportType, typeOfSports, establish }) => {
  return (
    <Fragment>
      <Row className="sideItem">
        <Col span={24}>
          <h1 className="timelineAboutpadding">Other</h1>
          <p className="timelinedesc">
            {nickname?.length > 0 && (
              <span
                style={{
                  display: "block",
                  fontWeight: "bold",
                  maxHeight: 250,
                  paddingTop: "1rem"
                }}>
                Nickname: {nickname}
              </span>
            )}
            {sportType && (
              <span
                style={{
                  display: "block",
                  fontWeight: "bold",
                  maxHeight: 250,
                  paddingTop: "1rem"
                }}>
                SportType: {sportType}
              </span>
            )}

            {dob && (
              <span
                style={{
                  display: "block",
                  fontWeight: "bold",
                  maxHeight: 250,
                  paddingTop: "1rem"
                }}>
                Date of Birth: {dob}
              </span>
            )}
            {typeOfSports && (
              <span
                style={{
                  display: "block",
                  fontWeight: "bold",
                  maxHeight: 250,
                  paddingTop: "1rem"
                }}>
                SportType: {typeOfSports}
              </span>
            )}
            {establish && (
              <span
                style={{
                  display: "block",
                  fontWeight: "bold",
                  maxHeight: 250,
                  paddingTop: "1rem"
                }}>
                Established Date: {establish}
              </span>
            )}
          </p>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Other;
